import { render, staticRenderFns } from "./beneficiary-list-1.vue?vue&type=template&id=49ff0c14&"
import script from "./beneficiary-list-1.vue?vue&type=script&lang=js&"
export * from "./beneficiary-list-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports